export default __webpack_public_path__ + "static/media/logo.8f528b21.webp";